import { Dispatch, SetStateAction, useEffect } from 'react'
import { getYear, getMonth } from 'libs/dates'

type UseSetQueryProps = {
	currentMonth: Date
	setQuery: Dispatch<SetStateAction<string | null>>
}

export const useSetQuery = ({ currentMonth, setQuery }: UseSetQueryProps) => {
	useEffect(() => {
		setQuery(`year=${getYear(currentMonth)}&month=${getMonth(currentMonth) + 1}`)
	}, [currentMonth])
}
